import { defineComponent as _defineComponent } from 'vue'
import type { CanvasEx } from '@/typings/canvas';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import ShadowSettings from '@/components/DesignStudio/ShadowSettings.vue';
import { useShadowSettings } from '@/composables/shadowSettings';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageShadowProperties',
  props: {
    canvas: null,
    imageElement: { default: undefined },
    editMode: { type: Boolean },
    cmykMode: { type: Boolean },
    isPreview: { type: Boolean, default: false },
    exportFormat: null
  },
  emits: ["shadow-change", "open-shadow-color-library-selector"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'shadow-change'): void;
    (e: 'open-shadow-color-library-selector'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { canvas: CanvasEx, imageElement: ImagePlaceholderElement, editMode?: boolean, cmykMode?: boolean, isPreview: boolean, exportFormat?: string };

/**
 * Shadow panel of an image placeholder. Everything that is not specific to an image lives in
 *  useShadowSettings + ShadowSettings: this only says which element to write into, and when an image
 *  can't cast a shadow.
 */




const shadow = useShadowSettings<ImagePlaceholderElement>({
    element: () => props.imageElement,
    canvas: () => props.canvas,
    editMode: () => props.editMode,
    exportFormat: () => props.exportFormat,
    // Same restriction the outline already has: a soft shadow can't survive being traced to a
    //  single flat color by potrace, so it only applies to full color and grayscale images
    supportsShadow: (element) => !!element.fullColor || !!element.grading,
    openLibrarySelector: () => emit('open-shadow-color-library-selector'),
    onShadowChange: () => emit('shadow-change')
});

return { __sfc: true,props, emit, shadow, ShadowSettings }
}

})